const  base_url = "https://obfys.docendorse.com";
let refreshOnDialogClose = false;
let dialogBox = null;
let isRunning = false;
let finalMessage = null;
let suppressAttachmentEvents = false;

function setToken(data){
  localStorage.setItem("access_token", data.access_token);
}

function get_token(){
  return localStorage.getItem("access_token");
}

function setVerifier(chl){
  localStorage.setItem("code_challenge",chl);
}

function getVerifier(){
  return localStorage.getItem("code_challenge");
}

function loginState(){
  return webFetchPromise({
      'url': base_url + '/api/v1/accounts/status',
      'type': 'get',
      'content': "application/json",
      'responseType': 'text',
      'authorization': get_token()
  });
}

function setScene(scene,data = {}){
  var visible_on_logged_out = Array.from(grabAll('.visible_on_logged_out')),
  visible_on_logged_in = Array.from(grabAll('.visible_on_logged_in')),
  visible_on_product_purchase = Array.from(grabAll('.visible_on_product_purchase')),
  tip = grab('.redact_tip'),
  profile = grab('.box-profile'),
  buy = grab('.buy_product');

  tip.innerHTML = "You need to connect your app to your Obfys account to redact documents";

  switch(scene){
    case 'signed_in':
      visible_on_logged_in.forEach(function(el) { el.showItem(); } );
      visible_on_logged_out.forEach(function(el) { el.hideItem(); } );
      visible_on_product_purchase.forEach(function(el) { el.showItem(); } );
      buy.hideItem();
      tip.hideItem();
      break;
    case 'signed_out':
      visible_on_logged_in.forEach(function(el){ el.hideItem(); } );
      visible_on_logged_out.forEach(function(el){ el.showItem(); } );
      visible_on_product_purchase.forEach(function(el) { el.hideItem(); } );
      tip.showItem();
      break;
    case 'signed_in_no_product':
      visible_on_logged_in.forEach(function(el) { el.showItem(); } );
      visible_on_logged_out.forEach(function(el) { el.hideItem(); } );
      visible_on_product_purchase.forEach(function(el) { el.hideItem(); } );
      tip.showItem();
      tip.innerHTML = "You need to purchase an Obfys subscription.";
      buy.showItem();
      break;
  }
  return setHTMLData(profile,data);
};

function setLoginState(){
    return new Promise(function(resolve,reject){
      let scene;
      loginState().then( (_state) => {
        var state = JSON.parse(_state);
        if (state.reg.status == 'success'){
          scene = setScene('signed_in',state.user);
        }else if (state.reg.status =='require_action') {
          if(state.reg.action == 'purchase_subscription'){
            scene = setScene('signed_in_no_product',state.user);
          } else if(state.reg.action == 'register'){
            scene = setScene('signed_out');
          } else if (state.reg.action == 'verify_email'){
            scene = setScene('signed_out');
            notify('Your email/account has not been verified. Please check your email for the verification link.','error');
          } else {
            scene = setScene('signed_out');
          }
        }
        scene.then(resolve).catch(reject);
      }).catch(function(err){
        scene = setScene('signed_out');
        scene.then(resolve).catch(reject);
      });
    });
};


function getOfficeDiagnostics() {
    var version = "",
    platform = "",
    host = "",
    platform_o = "";

    if (typeof Office !== "undefined" &&
        Office.context &&
        Office.context.diagnostics) {

        if (Office.context.diagnostics.version) {
            version = Office.context.diagnostics.version;
        }

        if (Office.context.diagnostics.platform) {
            platform = Office.context.diagnostics.platform;
        }
    }

    if (typeof Office !== "undefined" && Office.context){
      if (Office.context.host) {
        host = Office.context.host;
      }
      if (Office.context.platform) {
        platform_o = Office.context.platform
      }
    }

    return {
        version: version,
        platform: platform,
        host: host,
        platform_o: platform_o
    };
};


function handleUploadError(err){
  if(err.status == 'no_perms'){
    notify('Your app is disconnected. Please reconnect','error');
    setLoginState().catch(function(){});
  } else if (err.status == 'purchase_plan_app_connection'){
    notify('You need to purchase a subscription','error');
    setLoginState().catch(function(){});
  } else {
    notify("Could not upload file please try again or contact support at support@docendorse.com",'error');
  }
};


function base64UrlEncode(bytes) {
  var str = btoa(String.fromCharCode.apply(null, bytes));
  return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

function randomString(length){
  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  var result = "";
  for (var i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

function pkceChallenge(verifier) {
  if (window.crypto && window.crypto.subtle) {
      var encoder = new TextEncoder();
      var data = encoder.encode(verifier);
      return crypto.subtle.digest("SHA-256", data).then(function (buffer) {
          return base64UrlEncode(new Uint8Array(buffer));
      });
  }
  return Promise.resolve(verifier);
};


function bufferToBase64(buffer) {
  return new Promise(function(r){
    var reader = new FileReader();
    reader.onload = function(){
      r(reader.result);
    }
    reader.readAsDataURL( new Blob(
      [new Uint8Array(buffer)],
      { type: 'application/pdf' }
      ));
  });
};


function processMessage(arg) {
  var message = JSON.parse(arg.message);
  switch(message.status){
    case 'oauth':
      if(message.data.hasOwnProperty('code')){
        getAccessTokenFromCode(message.data.code).then(function(data){
          setToken(data);
          setLoginState().then(function(){
            notify("App authenticated",'success');
          }).catch(function(){
            notify("App authentication failed",'error');
          }).finally(function(){
            dialogBox.close();
          });
        }).catch(function(err){
          notify("Could not authenticate app.",'error');
          dialogBox.close();
        });
      } else {
        notify("Could not authenticate " + message.data.error_code,'error');
      }
      break;
    case 'success_app_updated':
    case 'purchase_success':
      setLoginState()
      .catch(function(){})
      .finally(function(){
        dialogBox.close();
        notify(message.description,'success');
      });
      break;
    case 'app_success':
      dialogBox.close();
      notify(message.description,'success');
      break;
    case 'finalize_redact':
      dialogBox.close();
      postRedaction(message);
      break;
    case 'app_error':
      dialogBox.close();
      notify(message.description,'error');
      break;
    case 'fail_app_updated':
      setLoginState()
      .catch(function(){})
      .finally(function(){
        dialogBox.close();
        notify(message.description,'error');
      });
      break;
    case 'close_dialog':
      dialogBox.close();
      break;
  }
};


function openDialog(url,refresh = false,displayInframe = false){
  Office.context.ui.displayDialogAsync(url,{
      displayInIframe: displayInframe
    },
    function(dbr){
    if(dbr.status === Office.AsyncResultStatus.Succeeded) {
      refreshOnDialogClose = refresh;
      dialogBox = dbr.value;
      dialogBox.addEventHandler(Office.EventType.DialogMessageReceived,processMessage);
      dialogBox.addEventHandler(Office.EventType.DialogEventReceived, processDialogEvent);
    } else {
      notify("Something went wrong internally, please contact support at support@docendorse.com",'error');
    }
  });
}


function redactDocument(item){
  if(item.status == 'success'){
    var url = base_url.concat('/apps/obfys_for_outlook/routines?',
      buildQuery({
        'instruct': 'init_document_redaction',
        'token': item.token || '',
        'transaction_id': item.transaction_id || '',
        'ref_path': "/apps/obfys_for_outlook/routines",
        'post_op': 'ext_links'
      })
    );
    openDialog(url);
  } else {
    notify("Could not upload file",'error');
  }
}

function connectAccount(){
  var codeVerifier = randomString(64);
  setVerifier(codeVerifier);
  pkceChallenge(codeVerifier).then(function (challenge){
    var params = buildQuery({
      'response_type': 'code',
      'client_id': 'client_7b736d773b15c1e2de1d14d35ad23430',
      'redirect_uri': 'https://obfys.docendorse.com/apps/obfys_for_outlook/auth-complete',
      'scope': 'openid accounts:read files:write',
      'code_challenge': challenge,
      'code_challenge_method': 'S256'
    });
    openDialog("https://obfys.docendorse.com/oauth2/v1/authorize?".concat(params));
  }).catch(function(){
    notify("Could not generate access code, please contact support at support@docendorse.com",'error');
  });
}


function disconnectAccount(){
  webFetchPromise({
    'url': "https://obfys.docendorse.com/oauth2/v2/revoke",
    'type': 'POST',
    'content': "application/x-www-form-urlencoded",
    'payload': { 'token': get_token() },
    'responseType': 'json',
  }).then(function(res){
      localStorage.clear();
      openDialog(
        base_url.concat('/apps/obfys_for_outlook/routines?',
          buildQuery({
            'instruct': 'disconnect_item',
          })
        )
      );
  });
}


function getAccessTokenFromCode(code){
  return webFetchPromise({
    'url': "https://obfys.docendorse.com/oauth2/v2/token",
    'type': 'POST',
    'content': "application/x-www-form-urlencoded",
    'payload': { 
      'code': code,
      'client_id': 'client_7b736d773b15c1e2de1d14d35ad23430',
      'redirect_uri': "https://obfys.docendorse.com/apps/obfys_for_outlook/auth-complete",
      'code_verifier': getVerifier(),
      'grant_type': "authorization_code",
     },
    'responseType': 'json',
  });
}


function generateToken(){
  return webFetchPromise({
    'url': "https://obfys.docendorse.com/api/v1/accounts/token",
    'type': 'GET',
    'content': "application/json",
    'authorization': get_token(),
    'responseType': 'json',
  });
}

function purchaseSubscriptionImmediately(){
  generateToken().then(function(item){
    if(item.status == 'success'){
      var url = base_url.concat('/apps/obfys_for_outlook/routines?',
        buildQuery({
          'instruct': 'init_purchase_now',
          'token': item.token || "",
          'ref_path': "/apps/obfys_for_outlook/routines"
        })
      );
      openDialog(url,true);
    } else {
      handleUploadError(item);
    }
  }).catch(function(){
    notify("Could not generate subscription link, please contact support",'error');
  });
};


function processDialogEvent(arg){
  switch (arg.error) {
    case 12002:
      notify("Cannot load page please contact support at support@docendorse.com.",'error');
      break;
    case 12003:
      notify("An unsecured page is being opened please contact support at support@docendorse.com","error");
      break;
    case 12006: 
      if(refreshOnDialogClose){
        setLoginState().catch(function(){});
        refreshOnDialogClose = false;
      }
      break;
    case 12009:
      notify("Blocking the pop up will prevent the operation from being carried out. Please enable the popup to continue.","error"); 
      break;
    case 12011:
      notify("Your browser is configured to block popups, please enable popup or use different browser to continue.","error"); 
      break;
    default: break;
  }
};



function getMode() {
  var item = Office.context.mailbox.item;
  if (
      item &&
      item.body &&
      typeof item.body.setAsync === "function"
  ) {
    return "compose";
  }
  return "read";
};


function postRedaction(data){
  if(data.hasOwnProperty('redacted_documents')){
    finalMessage = data;
    if(getMode() == 'compose'){
      notify("Select how you would like to handle the redacted file attachments.",{
        style: 'outlook-compose',
        clickToHide: false,
        autoHide: false,
      });
    } else {
      notify("What would like to do next with the redacted attachment(s)?",{
        style: 'outlook-read',
        clickToHide: false,
        autoHide: false,
      });
    }
  } else {
    notify(data.description,'success');
  }
};


function syncAttachmentObjects(listObjects, attachmentList) {
  var result = [];
  var attachmentMap = {};
  for (var i = 0; i < attachmentList.length; i++) {
      attachmentMap[attachmentList[i].id] = attachmentList[i];
  }

  for (var j = 0; j < listObjects.length; j++) {
      var item = listObjects[j];
      if (item.type === "attachment") {
        if (attachmentMap[item.id]) {
          result.push(item);
        }
      } else {
        result.push(item);
      }
  }

  for (var k = 0; k < attachmentList.length; k++){
    var att = attachmentList[k];
    var exists = false;

    for (var m = 0; m < result.length; m++) {
      if (result[m].type === "attachment" && result[m].id === att.id) {
        exists = true;
        break;
      }
    }

    if (!exists) {
      result.push({
          id: att.id,
          type: "attachment",
          name: att.name || "",
          file: []
      });
    }
  }
  return result;
};



function isMismatch(listObjects, attachmentList){
  for (var i = 0; i < attachmentList.length; i++) {
    var att = attachmentList[i];
    var found = false;

    for (var j = 0; j < listObjects.length; j++){
      var item = listObjects[j];
      if ( item.type === "attachment" && item.id === att.id ) {
        found = true;
        break;
      }
    }
    if (!found) {
      return true;
    }
  }

  for (var k = 0; k < listObjects.length; k++) {
    var obj = listObjects[k];
    if (obj.type !== "attachment") {
      continue;
    }

    var exists = false;
    for (var m = 0; m < attachmentList.length; m++) {
      if (obj.id === attachmentList[m].id) {
        exists = true;
        break;
      }
    }
    if (!exists) {
      return true;
    }
  }
  return false;
};




function normalizeName(name) {
  return (name || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");
};


function base64ToBlob(base64, mimeType) {
  const sliceSize = 1024;
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset,offset + sliceSize);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] =
      slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, {type: mimeType});
};

function base64ToBlobFull(base64,mimeType){
  const binary = atob(base64);
  const length = binary.length;
  const bytes = new Uint8Array(length);
  for (let i = 0; i < length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes],{type: mimeType});
};


function exportEmailAsTextFile() {
  return new Promise(function(resolve,reject){
    const item = Office.context.mailbox.item;
     item.body.getAsync(Office.CoercionType.Text, function(result){
        if (result.status !== Office.AsyncResultStatus.Succeeded) {
        reject(result.error);
          return;
        }
        const content = (item.subject || "") + "\n\n"  + "Body" + result.value || "";
        const blob = new Blob([content],{ type: "text/plain;charset=utf-8" });
        resolve(blob);
      }
    );
  });
};


function getAttachments() {
  const item = Office.context.mailbox.item;
  if (typeof item.getAttachmentsAsync === "function") {
    return new Promise(function(resolve, reject){
      item.getAttachmentsAsync(function(result){
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve(result.value || []);
        } else {
          reject(result.error);
        }
      });
    });
  }
  return Promise.resolve(item.attachments || []);
};

function getItemID(){
  return new Promise(function(resolve,reject){
    let itemId = Office.context.mailbox.item.itemId || null;
    if(isVarSet(itemId)){
      resolve(itemId);
    } else {
      if(Office.context.requirements.isSetSupported("Mailbox","1.8")){
        Office.context.mailbox.item.getItemIdAsync(function(result){
          if (result.status === Office.AsyncResultStatus.Failed) {
            reject(result.error.message);
            return;
          }
          itemId = result.value;
          if(isVarSet(itemId)){
            resolve(itemId);
          } else {
            Office.context.mailbox.item.saveAsync(function(result) {
              if (result.status === Office.AsyncResultStatus.Failed) {
                reject(result.error.message);
                return;
              }
              resolve(result.value);
            });
          }
        });
      } else {
        Office.context.mailbox.item.saveAsync(function(result) {
          if (result.status === Office.AsyncResultStatus.Failed) {
            reject(result.error.message);
            return;
          }
          resolve(result.value);
        });
      }
    }
  });
};


function attachmentToBlobV1(att) {
  return new Promise(function(resolve, reject){
    Office.context.mailbox.item.getAttachmentContentAsync(att.id,function(result){
        if (result.status !== Office.AsyncResultStatus.Succeeded) {
          reject(result.error);
          return;
        }
        const blob = base64ToBlobFull(result.value.content,"application/octet-stream");
        resolve(blob);
      }
    );
  });
};


function findGraphAttachmentID(officeAttachment, graphAttachments) {
  if (!officeAttachment || !Array.isArray(graphAttachments)) {
    return null;
  }

  const officeName = normalizeName(officeAttachment.name);
  const officeSize = officeAttachment.size;
  let match = graphAttachments.find(function(g){
    return (normalizeName(g.name) === officeName && g.size === officeSize);
  });

  if (match) return match.id;
  match = graphAttachments.find(function(g) {return normalizeName(g.name) === officeName;});
  return match ? match.id : null;
};


function attachmentToBlobV2(att){
  return new Promise(function(resolve,reject){
    getItemID().then(function(itemId){
      const restId = Office.context.mailbox.convertToRestId(itemId,Office.MailboxEnums.RestVersion.v2_0);
      const graph = "https://graph.microsoft.com/v1.0";
      AuthProvider.getAccessToken()
        .then( function(token){
          webFetchPromise({
            'url': graph.concat("/me/messages/",restId,"/attachments"),
            'type': 'GET',
            'responseType': 'json',
            'authorization': token
          }).then(function(data){
            const gAtt = findGraphAttachmentID(att,data['value']);
            if(isVarSet(gAtt)){
              webFetchPromise({
                'url': graph.concat("/me/messages/",restId,"/attachments/",att.id,"/$value"),
                'type': 'GET',
                'responseType': 'blob_uint',
                'authorization': token
              }).then(function(data){
                resolve(data);
              }).catch(reject);
            } else {
              throw new Error('Could not locate attachment ID on server');
            }
          }).catch(reject);
        }).catch(reject);
    }).catch(reject)
  });
};

function getAttachmentBlob(att){
  return new Promise(function(resolve,reject){
    attachmentToBlobV1(att).then(resolve).catch(function(){
      attachmentToBlobV2(att).then(resolve).catch(reject);
    });
  });
};


function uploadFormData(formData){
  return webFetchPromise({
    'url': "https://obfys.docendorse.com/api/v1/files/upload",
    'type': 'POST',
    'responseType': 'json',
    'authorization': get_token(),
    'payload' : formData
  });
};


function scanText(formData){
  return webFetchPromise({
    'url': "https://obfys.docendorse.com/api/v1/files/classify_sensitive_content",
    'type': 'POST',
    'responseType': 'json',
    'authorization': get_token(),
    'payload' : formData
  });
};


function addAttachments( files, done) {
    var index = 0;
    var amount_added = 0;
    suppressAttachmentEvents = true;
    function next() {
        if (index >= files.length) {
          if (done) {
            done({
              total_files: files.length,
              amount_added
            });
          }
          suppressAttachmentEvents = false;
          return;
        }
        var file = files[index];
        Office.context.mailbox.item.addFileAttachmentAsync( file.file_url,file.baseName,function (result) {
          if ( result.status ===Office.AsyncResultStatus.Succeeded) {
            amount_added++;
          } else {
          }
          index++;
          next();
        });
    }
    next();
};




function displayReplyForm(html_item,_attachments){
  return new Promise(function(resolve,reject){
    if(typeof Office.context.mailbox.item.displayReplyForm === 'function'){
      if (typeof Office.context.mailbox.item.displayReplyFormAsync === 'function'){
        Office.context.mailbox.item.displayReplyFormAsync({
            htmlBody: html_item,
            attachments: _attachments
          },function(asyncResult){
            if (asyncResult.status === Office.AsyncResultStatus.Failed) {
              reject("Could not open reply form.");
            } else {
              resolve(asyncResult.value);
            }
        });
      } else {
        Office.context.mailbox.item.displayReplyForm({
          htmlBody : html_item,
          attachments : _attachments,
          callback : function(asyncResult) {
            if (asyncResult.status === Office.AsyncResultStatus.Failed){
              reject("Could not open reply form.");
            } else {
              resolve(asyncResult.value);
            }
          }
        });
      }
    } else {
      reject('Automatic replies not supported');
    }
  });
};


function removeAttachments(attachments,done) {
  var index = 0;
  suppressAttachmentEvents = true;
  function next() {
    if (index >= attachments.length) {
        if (done) {
          done();
        }
        suppressAttachmentEvents = false;
        return;
    }

    var attachment =attachments[index];
    Office.context.mailbox.item.removeAttachmentAsync(attachment.id,function (result) {
      if (result.status ===Office.AsyncResultStatus.Succeeded) {
      } else {
      }
      index++;
      next();
    });
  }
  next();
};

function downloadFileObject(url) {
  return new Promise(function (resolve,reject) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET",url,true);
    xhr.responseType = "blob";
    xhr.withCredentials = false;
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) { return; }
      if ( xhr.status < 200 || xhr.status >= 300) {
          reject( new Error( "Download failed with status " + xhr.status ));
          return;
      }

      try {
          var disposition = xhr.getResponseHeader("Content-Disposition");
          var contentType = xhr.getResponseHeader("Content-Type");
          var fileName = "redacted_download";
          if ( disposition) {
              var match = disposition.match( /filename="?([^"]+)"?/i);
              if ( match && match[1] ) {
                  fileName = match[1];
              }
          }
          var blobUrl = window.URL.createObjectURL(xhr.response);
          var a = document.createElement("a");
          a.href = blobUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout( function () {
            window.URL.revokeObjectURL(blobUrl);
          },1000);
          resolve({fileName: fileName, blob: xhr.response});
      } catch (err) {
        reject(err);
      }
    };

    xhr.onerror = function () {
      reject( new Error("Network error during download" ));
    };

    xhr.ontimeout = function () {
      reject(new Error("Download timed out"));
    };

    xhr.onabort = function () {
      reject(new Error("Download aborted"));
    };

    try {
      xhr.send();
    } catch (err) {
      reject(err);
    }
  });
};


const outlookPane = {
  main_container: grab('.main_container'),
  secondary_container: grab('.profile-card'),
  loading_cover:  grab('.loading_cover'),
  spinner: grab('.spinner'),
  connect_account: grab('.main_login_sign_up'),
  disconnect_account: grab('.main_logout_sign_up'),
  buy_product: grab('.buy_product'),
  pendingFiles: [],
  attachment_list: grab('.attachment_list'),
  get_attachments_redacted: grab("[name=get_attachments_redacted]"),
  uploadSign: null,
  options_list: grab("#options_list"),
  scan_body: grab("[name=scan_body]"),
  body_keyword_list: grab(".body_keyword_list"),
  apply_redact_body: grab("[name=apply_redact_body]"),
  undo_redact_body: grab("[name=undo_redact_body]"),

  tmp1: '<div data-item="{2}" data-file-id="{1}" class="signature_list_item">'+
          '<span class="d-flex">'+
            '<img class="regular_background image-icon" src="https://obfys.docendorse.com/sitepkg/img/icons/file-120.png" width="20">'+
            '<p class="title">{0}</p>'+
            '<span class="mdi mdi-close-circle-outline align-self-center ml-auto"></span>'+
          '</span>'+
        '</div>',

  tmp2: '<div class="group-label">{0}</div>',

  tmp3: '<div data-text="" class="item">'+
          '<label class="checkbox style-c">'+
              '<input type="checkbox"/>'+
              '<div class="checkbox__checkmark"></div>'+
              '<div class="checkbox__body">{0}</div>'+
          '</label>'+
      '</div>',
  
  acceptableFiles: [
    'image/jpeg',
    'image/png',
    'image/bmp',
    'application/vnd.ms-powerpoint',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.oasis.opendocument.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ],

  acceptableExtensions: [ 'pdf','jpeg','jpg','docx','doc','ppt','pptx','png','bmp' ],


  setUpPillLinks: function(){
    const nav_links = Array.from(grabAll('.nav-item > .nav-link'));
    nav_links.forEach(function(link) {
      link.addEventListener('click', function(evt) {
        evt.preventDefault();
        nav_links.forEach( function(l) {
          l.classList.remove('active');
          l.setAttribute('aria-selected',false);
          document.getElementById(l.hash.substr(1)).classList.remove('show','active');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected',true);
        document.getElementById(this.hash.substr(1)).classList.add('show','active');
      });
    });
  },

  setUpCategories: function() {
    const clc = getBrowserCountry(),
    options_list = this.options_list,
    save_settings = grab("[name=save_settings]"),
    add_county = ['US','CA','GB',"JM","AU","NZ"];

    Array.from(grabAll("[name=phone_country],[name=address_country],[name=date_country]")).forEach(function(el){
      let scc = stripeAccountCountries;
      let clcc = clc || 'US';

      if(el.name == 'address_country' ){
        scc = stripeAccountCountries.filter(function(c){
            return add_county.includes(c.code);
        });
        if(!add_county.includes(clcc.toUpperCase())) clcc = 'US';
      }

      el.addEventListener('change',function(evt){
        if ( this.value.length > 0){
          this.parentNode.className = "custom_country flag-ic-" + this.value.toLowerCase();
        }
      });

      el.addOptions(scc,{
        'default': 'Country',
        'value': 'code',
        'name': 'country',
        'initial': clcc
      });
    });

    save_settings.addEventListener('click',function(){
      const options = Serialize(options_list);
      localStorage.setItem('outlook_category_settings',JSON.stringify(options));
      notify("Settings saved",'success');
    });

    const cat_settings = localStorage.getItem('outlook_category_settings');
    if(isVarSet(cat_settings)){
      assignValue(options_list,JSON.parse(cat_settings));
    }
  },

  setHeading: function() {
    var heading = grab(".heading_for_email");
    var item = Office.context.mailbox.item;
    if(typeof item.subject.getAsync == "function" ){
      item.subject.getAsync(function (result) {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          var subject = result.value || "New Email";
          heading.innerHTML = "Subject: " + subject;
        } else {
          heading.innerHTML = "Subject: New Email";
        }
      });
    } else {
      var subject = item.subject || "New Email";
      heading.innerHTML = "Subject: " + subject;
    }
  },

  mainButtons: function() {
    const _this = this;
    this.connect_account.addEventListener('click',connectAccount);
    this.disconnect_account.addEventListener('click',disconnectAccount);
    this.buy_product.addEventListener('click',function(){ purchaseSubscriptionImmediately(); });

    this.attachment_list.addEventListener('click',function(evt){
      let closeBtn;
      if( isVarSet(closeBtn = evt.target.closest('.mdi-close-circle-outline')) ){
        const container = closeBtn.parentNode.parentNode;
        const fId = container.dataset.fileId;
        const index = _this.pendingFiles.findIndex(function(item){return item.id === fId});
        if (index !== -1) { _this.pendingFiles.splice(index, 1);}
        container.remove();
      }
    });
  },


  setUpBodyScan: function(){
    const _this = this;
    let scanningBody = false;
    let originalHTML = null;
    let isRedacting = false;
    this.scan_body.addEventListener('click',function(evt){
      if(scanningBody){
        notify("Currently scanning body.","success");
        return;
      }
      const b_this = this;
      this.firstElementChild.firstElementChild.makeVisible();
      const categories = Array.from(_this.options_list.children).map(function(c){
        return Serialize(c);
      }).filter(function(f){
        const keys = Object.keys(f);
        return f[ keys[0] ] == true;
      }).map(function(s){
        const items = Object.keys(s);
        return {
          name: items[0],
          country: s[items[1]] || "GB"
        };
      });

      scanningBody = true;
      exportEmailAsTextFile().then(function(blob){
        const fD = new FormData();
        fD.append('text-1',blob);
        const metadata = JSON.stringify({
          docutype: 'user_document_to_sign',
          categories: categories
        });
        const _metadata = new Blob([metadata],{ type: "application/json"});
        fD.append("metadata",_metadata);

        scanText(fD).then(function(scan){
          if(scan.status == 'success'){
            if (scan.results.unique.length > 0){
              _this.body_keyword_list.empty();
              let processed_tokens = [];
              for (var cat in scan.results.categories){
                const categories = scan.results.categories[cat];
                if (categories.length>0){
                  _this.body_keyword_list.appendChild(stringToHTML( String.format(_this.tmp2, cat.capitalize()) ));
                  categories.forEach(function(token){
                    if (!processed_tokens.includes(token.text)){
                      const el = stringToHTML( String.format(_this.tmp3,token.text) );
                      el.setAttribute('data-text',token.text);
                      _this.body_keyword_list.appendChild( el);
                      processed_tokens.push(token.text);
                    }
                  }); 
                }  
              }
              b_this.firstElementChild.firstElementChild.makeHidden();
              scanningBody =false;
              notify("Scan complete","success");
            } else {
              scanningBody =false;
              b_this.firstElementChild.firstElementChild.makeHidden();
              notify('No sensitive information found based on your search criteria.','error');
            }
          } else {
            scanningBody =false;
            b_this.firstElementChild.firstElementChild.makeHidden();
            notify('Could not process this email','error');
          }
        }).catch(function(){
          scanningBody =false;
          b_this.firstElementChild.firstElementChild.makeHidden();
        });
      }).catch(function(){
        scanningBody =false;
        b_this.firstElementChild.firstElementChild.makeHidden();
      });

    });


    this.apply_redact_body.addEventListener('click',function(evt){

      if(isRedacting) { notify("Currently redacting body","error"); return; }

      isRedacting = true;
      Office.context.mailbox.item.body.getAsync( Office.CoercionType.Html,function(result){
        if (result.status !== Office.AsyncResultStatus.Succeeded) {
          notify("Could not get email body in the right format",'error');
          isRedacting = false;
          return;
        }

        if(originalHTML==null){ HtmlHistory.init(result.value); }
        HtmlHistory.pushSnapshot();
        originalHTML = result.value;

        const items = Array.from(
          _this.body_keyword_list.querySelectorAll('input[type="checkbox"]:checked')
        ).map(function(c){
          return c.closest('[data-text]').dataset.text;
        });

        const parser = new DOMParser();
        const doc = parser.parseFromString(result.value,'text/html');
        DOMRedactor.redactTerms(doc.body,items);

        const updatedHtml = doc.body.innerHTML;
        HtmlHistory.setCurrentHtml(updatedHtml);

        if (typeof Office.context.mailbox.item.body.setAsync === "function") {
          Office.context.mailbox.item.body.setAsync(updatedHtml,{
            coercionType: Office.CoercionType.Html
          },function(result){ 
            if (result.status !== Office.AsyncResultStatus.Succeeded) {
              notify("Could not update email body",'error');
              return;
            }
            notify("Body has been redacted",'success');
            isRedacting = false;
          });
        } else {
          isRedacting = false;
          notify("This email is currently opened in read mode. To apply body redactions, create a reply or forward draft first.",'warn');
        }
        
      });
    });
    
    this.undo_redact_body.addEventListener('click',function(evt){
      if (typeof Office.context.mailbox.item.body.setAsync === "function") {
        var previous = HtmlHistory.undo();
        if (previous == null) {
          return;
        }
        Office.context.mailbox.item.body.setAsync(previous,{ 
          coercionType: Office.CoercionType.Html
        });
      } else {
         notify("Cannot modify email body in read mode","error");
      }
    });

  },

  fileUpload: function(){
    const _this = this,
    init_upload = grab(".file_upload_input_label"),
    file_input = grab('#file_upload_input'),
    drop_box = grab(".drop_area"),
    uploadSign = new UploadListener(init_upload,file_input,drop_box);
    this.uploadSign = uploadSign;

    uploadSign.on('processFiles',function(files){
      for(var i =0; i< files.length; i++){
        const _id = create_uuid();
        let _file = files[i];
        _this.pendingFiles.push({
          id: _id,
          file: _file,
          type: 'upload',
          name: _file.name
        });
        _this.attachment_list.appendChild(
          stringToHTML(String.format(_this.tmp1,_file.name,_id,'upload'))
        );
      }
    });
    file_input.accept = _this.acceptableFiles.join(",");
  },

  buildAttachmentList: function() {
    const _this = this;
    getAttachments().then(function(attachments){
      let files = attachments.filter(function(att){
        if (att.isInline) {
          return false;
        }
        const ext = att.name.getExtension();
        return _this.acceptableExtensions.includes(ext);
      });

      for(var i =0; i< files.length; i++){
        _this.pendingFiles.push({
          id: files[i].id,
          file: [],
          type: 'attachment',
          name: files[i].name,
          size: files[i].size
        });

        _this.attachment_list.appendChild(
          stringToHTML(String.format(_this.tmp1,files[i].name,files[i].id,'attachment'))
        );
      }
    }).catch(function(err){});
  },

  buildAttachmentListener: function(){
    const _this = this,
    item = Office.context.mailbox.item;
    const supported = Office.context.requirements.isSetSupported("Mailbox","1.8");
    if(supported && item.itemType === Office.MailboxEnums.ItemType.Message){
      item.addHandlerAsync(Office.EventType.AttachmentsChanged,function (eventArgs) {
        if(suppressAttachmentEvents==true) return;
          getAttachments().then(function(_attachments){
            const attachments = _attachments.filter(function(att) {
              if (att.isInline) {
                return false;
              }
              const ext = att.name.getExtension();
              return _this.acceptableExtensions.includes(ext);
            });
            _this.pendingFiles = syncAttachmentObjects(_this.pendingFiles, attachments);
            _this.attachment_list.empty();

            _this.pendingFiles.forEach(function(pf){
              _this.attachment_list.appendChild(
                stringToHTML(String.format(_this.tmp1,pf.name,pf.id,pf.type))
              );
            });
          }).catch(function(){
          });
      });
    }
  },

  loadPendingFiles: function() {
    let _this = this,
    formData = new FormData(),
    processed = 0,
    files = _this.pendingFiles;

    const worker = function(resolve, reject){
        if(processed >= files.length){
            return resolve(formData);
        }
        const index = processed;
        const _file = files[index];

        if(_file.type == 'upload'){
          formData.append("file-".concat(index),_file.file,_file.name);
          processed++;
          return worker(resolve, reject);
        }

        getAttachmentBlob(_file).then(function(blob){
          formData.append("file-".concat(index),blob,_file.name);
          processed++;
          worker(resolve, reject);
        }).catch(reject);
    };
    return new Promise(worker);
  },

  runFileTransfer: function(){
    const _this = this;

    this.loadPendingFiles().then(function(formData){

      const metadata = JSON.stringify({
        docutype: 'user_document_to_sign',
        categories: Serialize(_this.options_list)
      });
      const _metadata = new Blob([metadata],{ type: "application/json"});
      formData.append("metadata",_metadata);
      uploadFormData(formData).then(function(result){
        _this.get_attachments_redacted.firstElementChild.firstElementChild.makeHidden();
        isRunning = false;
        redactDocument(result);
      }).catch(function(err){
        _this.get_attachments_redacted.firstElementChild.firstElementChild.makeHidden();
        isRunning = false;
        notify(err.statusText,"error");
      });
    }).catch(function(err){
      _this.get_attachments_redacted.firstElementChild.firstElementChild.makeHidden();
      isRunning = false;
      notify(err.message,"error");
    }).finally(function(){
       _this.uploadSign.clearFileInput();
    });
  },

  buildRedactionImplimentor: function(){
    const _this = this;

    _this.get_attachments_redacted.addEventListener('click',function(evt){
      const btn = this;
      if(!isRunning){
        if (_this.pendingFiles.length >0){
          getAttachments().then(function(attachments){
            btn.firstElementChild.firstElementChild.makeVisible();
            isRunning = true;
            let items = attachments.filter(function(att) {
              if (att.isInline) {
                return false;
              }
              const ext = att.name.getExtension();
              return _this.acceptableExtensions.includes(ext);
            }).map(function(m){
              return{
                id: m.id,
                type: 'attachment',
                name: m.name,
                file: [],
              };
            });
            const storedAttchments = _this.pendingFiles.filter(function(pf){
              return pf.type == 'attachment';
            });
            if(isMismatch(storedAttchments,items)){
              notifyConfirm("Some attachments added to your email are missing here, do you want to add them?")
              .on('yes',function(){
                _this.pendingFiles = syncAttachmentObjects(_this.pendingFiles,items);
                _this.runFileTransfer();
              })
              .on('no',function(){
                _this.runFileTransfer();
              });
            } else {
              _this.runFileTransfer();
            }
          }).catch(function(err){
            isRunning = false;
            notify("Could not validate attachments","error");
          });
        } else {
          notify("You have no attachments listed.","error");
        }
      } else {
        notify("Currently processing attachments.","error");
      }
    });
  },

  followUpWorkflowListener: function(){

    const _this = this;
    document.addEventListener("click", function (event) {
      let btn=null;
      if(isVarSet(btn = event.target.closest(".notifyjs-outlook-compose-base [name=replace_original]"))){
        addAttachments(finalMessage.redacted_documents.items,function(res){
            const to_remove = _this.pendingFiles.filter(function(pf){return pf.type == 'attachment';});
            removeAttachments(to_remove,function(){
              if(res.total_files !== res.amount_added){
                notify("Some of the redacted files were not attached to the email, would you like to download them?",{
                  style: 'outlook-yn',
                  clickToHide: false,
                  autoHide: false,
                });
              } else {
                notify("We added your redacted files and replaced any that was present.",'success');
              }
            });     
        });
      } else if (isVarSet(btn = event.target.closest(".notifyjs-outlook-compose-base [name=add_along]")) ){
        addAttachments(finalMessage.redacted_documents.items,function(res){
          if(res.total_files !== res.amount_added){
            notify("Some of the redacted files were not attached to the email, would you like to download them?",{
              style: 'outlook-yn',
              clickToHide: false,
              autoHide: false,
            });
          } else {
            notify("All redacted files were added alongside your original attachments.",'success');
          }   
        });
      } else if (isVarSet(btn = event.target.closest(".notifyjs-outlook-compose-base [name=download_file]"))) {
        downloadFileObject(finalMessage.redacted_documents.download_enclosure).then(function(dwn){
          notify("Redacted files downloaded.",'success');
        }).catch(function(err){
          notify(err.message,'error');
        });
      } else if (isVarSet(btn = event.target.closest(".notifyjs-outlook-compose-base [name=continue]"))){
         notify(finalMessage.description,'success');
      } else if (isVarSet(btn = event.target.closest(".notifyjs-outlook-read-base [name=continue]"))){
         notify(finalMessage.description,'success');
      } else if (isVarSet(btn = event.target.closest(".notifyjs-outlook-read-base [name=reply]"))){
        const _attachments = finalMessage.redacted_documents.items.map(function(d){
            return {
              type: Office.MailboxEnums.AttachmentType.File,
              name : d.baseName,
              url : d.file_url,
              inLine: false,
            }
        });
        displayReplyForm('<p>Please see the attached redacted document(s).</p>',_attachments)
        .then(function(){}).catch(function(){
          notify("Could not add the redacted files to the reply email, would you like to download them?",{
            style: 'outlook-yn',
            clickToHide: false,
            autoHide: false,
          });
        });
      } else if (isVarSet(btn = event.target.closest(".notifyjs-outlook-read-base [name=download_file]"))){
        downloadFileObject(finalMessage.redacted_documents.download_enclosure).then(function(dwn){
          notify("Redacted files downloaded.",'success');
        }).catch(function(err){
          notify(err.message,'error');
        });
      } else if (isVarSet(btn = event.target.closest(".notifyjs-outlook-yn-base [name=yes]"))){
         downloadFileObject(finalMessage.redacted_documents.download_enclosure).then(function(dwn){
          notify("Redacted files downloaded.",'success');
        }).catch(function(){
           notify(err.message,'error');
        });
      } else if (isVarSet(btn = event.target.closest(".notifyjs-outlook-yn-base [name=no]"))){
        notify(finalMessage.description,'success');
      }
      if(btn){
        const container = btn.closest('.notifyjs-wrapper');
        event.stopPropagation();
				event.preventDefault();
        container.dispatchEvent( new CustomEvent("notify-hide", { bubbles: true }) );
      }
    });
  },


  init: function(info){
    const _this = this;
    if (info.host === Office.HostType.Outlook) {
      this.pendingFiles = [];
      this.setUpPillLinks();
      this.setUpCategories();
      this.setHeading();
      this.mainButtons();
      this.fileUpload();
      this.buildAttachmentList();
      this.buildAttachmentListener();
      this.buildRedactionImplimentor();
      this.setUpBodyScan();
      this.followUpWorkflowListener();
      this.secondary_container.hideItem();
      this.main_container.showItem();
      
      setLoginState().then(function(){
      }).catch(function(err){
      }).finally(function(){
        _this.loading_cover.classList.add('hide-loading');
      });
    } else {
      this.secondary_container.showItem();
      this.main_container.hideItem();
      this.loading_cover.classList.add('hide-loading');
    }
  }
};

Office.onReady(function(info){
  if (navigator.userAgent.indexOf("Trident") == -1){
    outlookPane.init(info);
  }
});



notify.addStyle('outlook-compose',{
    html: 
    '<div>'+
        '<div class="outlook-notification-card">'+
            '<div class="outlook-notification-body">'+
                '<p data-notify-text></p>'+
                '<div class="outlook-notification-actions">'+
                    '<button name="replace_original" class="outlook-notification-btn affirmative">Replace Originals</button>'+
                    '<button name="add_along" class="outlook-notification-btn outlook-notification-btn-secondary">Add redacted Files</button>'+
                    '<button name="download_file" class="outlook-notification-btn outlook-notification-btn-secondary">Download Files</button>'+
                    '<button name="continue" class="outlook-notification-btn btn-light" >Continue</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>'
});


notify.addStyle('outlook-read',{
    html: 
    '<div>'+
        '<div class="outlook-notification-card">'+
            '<div class="outlook-notification-body">'+
                '<p data-notify-text></p>'+
                '<div class="outlook-notification-actions">'+
                    '<button name="reply" class="outlook-notification-btn affirmative">Create Redacted Reply</button>'+
                    '<button name="download_file" class="outlook-notification-btn outlook-notification-btn-secondary">Download Files</button>'+
                    '<button name="continue" class="outlook-notification-btn btn-light" >Continue</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>'
});

notify.addStyle('outlook-yn',{
    html: 
    '<div>'+
        '<div class="outlook-notification-card">'+
            '<div class="outlook-notification-body">'+
                '<p data-notify-text></p>'+
                '<div class="outlook-notification-actions">'+
                    '<button name="yes" class="outlook-notification-btn btn-secondary">Yes</button>'+
                    '<button name="no" class="outlook-notification-btn btn-secondary">No</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>'
});
